module.exports = __webpack_public_path__ + "img/logo_image.5db32cdc.png";